import {
  Button,
  Checkbox,
  Divider,
  Input,
  Modal,
  Popconfirm,
  Switch,
} from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

import { StopOutlined } from "@ant-design/icons";
import { Flex, Radio } from "antd";
import { clubHasFinance } from "~/featureMatrix.jsx";
import { i18n } from "~/i18n.js";
import { emptyFlight } from "~/redux/flights/flights.state.js";
import { generate_uuid, selectElementByID } from "../../lib/helpers.js";
import { IGCButton } from "../IGC/IGC.button.jsx";
import { AnnuleerButton } from "../buttons/AnnuleerButton.jsx";
import { SaveButton } from "../buttons/SaveButton.jsx";
import { HelpBubble } from "../help/helpBubble.jsx";
import { LandingIcon, StartIcon } from "../icon/icon.jsx";
import { SelectPilot } from "../profile/selectPilot.jsx";
import { VoucherSelector } from "../voucher/VoucherSelector.jsx";
import { CategorySelect } from "./sections/categorySelect.jsx";
import { SectionKist } from "./sections/sectionKist.jsx";
import {
  calculateLandingTimeBasedOnNewStarttime,
  SectionTijd,
} from "./sections/sectionTijd.jsx";
import { SleepActions } from "./sections/sleepActions.jsx";
import { FlightTacometer } from "../form/FlightTacometer.jsx";

export const FlightSleepModal = ({
  visible,
  onClose,
  readOnly,
  sleepFlight,
  allFlights,
  updateFlight,
  kisten,
  sleep_kisten,
  vliegers,
  aanmeldingen,
  currentUser,
  sleep_cat,
}) => {
  if (!sleepFlight) return null;

  const [visibleSleepFlight, setVisibleSleepFlight] = useState({});
  const [visibleFlight, setVisibleFlight] = useState({});

  const hasFinance = clubHasFinance();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (sleepFlight) {
      if (sleepFlight.missing_sleep) {
        // We are actually dealing with a sleep flight that is missing the aerotow, so it's reversed
        const new_uuid = generate_uuid();
        setVisibleSleepFlight({
          // create a new sleep flight object
          ...emptyFlight,
          uuid: new_uuid,
          start_methode: "tmg-a",
          dag_id: sleepFlight.dag_id,
          datum: sleepFlight.datum,
          sleep_uuid: sleepFlight.uuid,
          start_tijd: sleepFlight.start_tijd,
          vertrek_vliegveld: sleepFlight.vertrek_vliegveld,
          aankomst_vliegveld: sleepFlight.aankomst_vliegveld,
          is_locked: sleepFlight.status === "locked",
        });
        setVisibleFlight({
          ...sleepFlight,
          sleep_uuid: new_uuid,
        });
      } else {
        setVisibleSleepFlight(sleepFlight);
        setVisibleFlight(
          sleepFlight.sleep_uuid &&
            selectElementByID(allFlights, "uuid", sleepFlight.sleep_uuid)
        );
      }

      setLoading(false);
    }
  }, [sleepFlight]);

  // check if selectedKist already exists, required for kist and tweede_inzittende registration
  const selectedSleepKist = selectElementByID(
    sleep_kisten,
    "registratie",
    visibleSleepFlight && visibleSleepFlight.registratie
  );

  const base_method =
    selectedSleepKist?.start_methode === "sep" ? "sep" : "tmg";
  let possible_start_methods = [`${base_method}-a`];
  if (!visibleSleepFlight?.sleep_uuid) {
    // only be able to select regular sep/tmg if no sleep flight is connected
    possible_start_methods.push(base_method);
  }
  if (!possible_start_methods.includes(visibleSleepFlight.start_methode)) {
    // if the flight input start method is not in the list, add it
    possible_start_methods.push(visibleSleepFlight.start_methode);
  }

  const selectedZweefKist = selectElementByID(
    kisten,
    "registratie",
    visibleFlight && visibleFlight.registratie
  );
  const betalendLid = selectElementByID(
    vliegers,
    "id",
    visibleSleepFlight && visibleSleepFlight.betalend_lid_id
  );

  const sleepVlieger = selectElementByID(
    vliegers,
    "id",
    visibleSleepFlight && visibleSleepFlight.gezagvoerder_id
  );
  const sleepVliegerTweedeInzittende = selectElementByID(
    vliegers,
    "id",
    visibleSleepFlight && visibleSleepFlight.tweede_inzittende_id
  );
  const isAerotow =
    visibleSleepFlight && visibleSleepFlight.start_methode?.endsWith("-a");

  const saveSleep = (newData) => {
    // note for the modal, we always save the complete flight element
    setVisibleSleepFlight({ ...visibleSleepFlight, ...newData });
  };

  const saveFlight = (newData) => {
    // note for the modal, we always save the complete flight element
    if (visibleFlight) setVisibleFlight({ ...visibleFlight, ...newData });
  };

  const disconnectSleepFlight = async () => {
    // function to disconnect sleep flight, e.g. when changing kist
    await saveSleep({
      sleep_uuid: "DELETE",
      start_methode: visibleSleepFlight.start_methode.replace("-a", ""),
      betalend_lid_id: visibleSleepFlight.gezagvoerder_id,
      voucher_id: "DELETE",
    });
    await saveFlight({
      sleep_uuid: "DELETE",
      start_methode: visibleFlight.start_methode.replace("-a", ""),
    });
  };

  const connectSleepFlight = async ({
    sleep_uuid,
    sleep_start_methode,
    flight,
  }) => {
    // function to connect sleep and update the sleep flight's start methode to match this flight
    let newFlight = {
      ...flight,
      sleep_uuid: visibleSleepFlight.uuid,
      start_methode: sleep_start_methode,
    };
    await setVisibleFlight(newFlight);

    await saveSleep({
      sleep_uuid: sleep_uuid,
      betalend_lid_id: newFlight?.betalend_lid_id,
      voucher_id: newFlight?.voucher_id,
    });
  };

  const addNewSleepFlight = async () => {
    // Create sleep_flight if not already connected
    const newFlightObject = {
      ...emptyFlight,
      dag_id: visibleSleepFlight.dag_id,
      datum: visibleSleepFlight.datum,
      is_locked: visibleSleepFlight.status === "locked",
      uuid: generate_uuid(),
      index: allFlights.length,
      start_methode: "sleep",
      vertrek_vliegveld: visibleSleepFlight.vertrek_vliegveld,
      aankomst_vliegveld: visibleSleepFlight.aankomst_vliegveld,
      order: 10000 + allFlights.length,
      sleep_uuid: visibleSleepFlight.uuid,
      start_tijd: visibleSleepFlight.start_tijd,
      betalend_lid_id: visibleSleepFlight.betalend_lid_id,
      voucher_id: visibleSleepFlight.voucher_id,
    };

    await saveSleep({
      sleep_uuid: newFlightObject.uuid,
    });
    await saveFlight(newFlightObject);
  };

  const [savingMethod, setSavingMethod] = useState(false);
  const saveNewmethod = (newValue) => {
    setSavingMethod(true);
    saveSleep({ start_methode: newValue });
    setSavingMethod(false);
  };

  const saveAndClose = async () => {
    setLoading(true);
    const hasRegularFlight = visibleFlight && visibleFlight.uuid;

    // possibly correct the betalend lid and voucher
    let payload = visibleSleepFlight;
    if (hasRegularFlight) {
      // save regular flight
      await updateFlight(visibleFlight);

      // make sure we set the betalend lid and voucher from the regular flight on the sleep
      payload["betalend_lid_id"] = visibleFlight.betalend_lid_id;
      payload["voucher_id"] = visibleFlight.voucher_id;
    }
    const data = await updateFlight(payload);
    setLoading(false);
    if (data) onClose();
  };

  const triggerDelete = async () => {
    setLoading(true);
    if (visibleFlight && visibleFlight.uuid) {
      console.log("Also deleting the visible Zweefflight");
      await updateFlight({ uuid: visibleFlight.uuid, action: "delete" });
    }
    await updateFlight({ uuid: visibleSleepFlight.uuid, action: "delete" });
    setLoading(false);
    onClose();
  };
  const [forceEdit, setForceEdit] = useState(false);
  readOnly =
    !forceEdit &&
    (readOnly ||
      (visibleSleepFlight &&
        (visibleSleepFlight.is_deleted || visibleSleepFlight.is_locked)));

  return (
    <Modal
      width={600}
      title={`${$t("Sleep")} ${visibleSleepFlight.start_tijd || ""}`}
      open={visible}
      onCancel={onClose}
      confirmLoading={loading}
      footer={[
        !visibleFlight || !visibleFlight.registratie ? (
          <Popconfirm
            placement="bottom"
            title={$t("Zeker weten dat je de vlucht wilt verwijderen")}
            onConfirm={triggerDelete}
            key="delete"
            okText={$t("Ja")}
            cancelText={$t("Nee")}
          >
            <Button
              icon={<StopOutlined />}
              danger
              loading={loading}
              disabled={readOnly}
            >
              {$t("Verwijder")}
            </Button>
          </Popconfirm>
        ) : null,

        <AnnuleerButton
          key="annuleren"
          style={{ marginLeft: 8 }}
          onClick={onClose}
        />,

        <SaveButton
          style={{ marginLeft: 8 }}
          key="opslaan"
          loading={loading}
          onClick={saveAndClose}
        />,
      ]}
    >
      <div>
        <p>{$t("Sleepkist")}: </p>
        <SectionKist
          isSleep={true}
          selectedKist={selectedSleepKist}
          kisten={sleep_kisten}
          flight={visibleSleepFlight}
          saveFlight={saveSleep}
          readOnly={readOnly}
        />

        <Flex gap={12} style={{ marginTop: 6 }} align="center">
          <p>{$t("Startmethode")}:</p>

          <Radio.Group
            size="small"
            buttonStyle="solid"
            disabled={savingMethod}
            value={visibleSleepFlight.start_methode}
            onChange={(e) => {
              saveNewmethod(e.target.value);
            }}
          >
            {possible_start_methods.map((method, idx) => (
              <Radio.Button value={method} key={idx}>
                {$t(method)}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Flex>

        {isAerotow && (
          <div style={{ marginTop: 12 }}>
            <p>{$t("Zweefkist")}:</p>
            {visibleFlight && (
              <SectionKist
                selectedKist={selectedZweefKist}
                kisten={kisten}
                flight={visibleFlight}
                saveFlight={saveFlight}
                readOnly={readOnly}
              />
            )}

            <div style={{ marginTop: 6 }}>
              <SleepActions
                flight={visibleSleepFlight}
                allFlights={allFlights}
                sleepFlight={visibleFlight}
                readOnly={readOnly}
                disconnectSleepFlight={disconnectSleepFlight}
                connectSleepFlight={connectSleepFlight}
                addNewSleepFlight={addNewSleepFlight}
              />
            </div>
          </div>
        )}

        <Divider orientation="left" plain>
          {$t("Vliegers")}
        </Divider>

        <div
          className="row"
          style={{ alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}
        >
          <p
            style={{
              marginTop: 5,
            }}
          >
            {$t("sleepvlieger")}:
          </p>
          <SelectPilot
            hideAvatar
            readOnly={readOnly}
            field_id="gezagvoerder_id"
            field_name="gezagvoerder_naam"
            title={$t("sleepvlieger")}
            pilot={sleepVlieger}
            otherPilot={null}
            // vliegers gezagvoerder only non-pax
            vliegers={aanmeldingen.filter(
              (aanmelding) => aanmelding.id > 0 && aanmelding.as_sleepvlieger
            )}
            alle_vliegers={vliegers}
            flight={visibleSleepFlight}
            saveFlight={saveSleep}
            openPilot={null}
          />
          {!sleepVlieger && (
            <Button
              disabled={readOnly}
              onClick={() => {
                let data = {
                  gezagvoerder: currentUser,
                  gezagvoerder_id: currentUser.id,
                  gezagvoerder_naam: currentUser.name,
                };

                // we can set the betalend lid irrespective of the voucher
                if (!isAerotow) {
                  if (
                    visibleSleepFlight.tweede_inzittende_id &&
                    visibleSleepFlight.is_fis
                  ) {
                    data.betalend_lid_id =
                      visibleSleepFlight.tweede_inzittende_id;
                  } else {
                    data.betalend_lid_id = currentUser.id;
                  }
                }
                saveSleep(data);
              }}
            >
              {$t("Voeg mij toe")}
            </Button>
          )}
        </div>

        {selectedSleepKist?.pilots > 1 && (
          <div
            className="row"
            style={{ marginTop: 6, flexWrap: "wrap", gap: 12 }}
          >
            <p
              style={{
                marginTop: 5,
              }}
            >
              2<sup>e</sup> {$t("Sleepvlieger")} :
            </p>
            <SelectPilot
              hideAvatar
              readOnly={readOnly}
              field_id="tweede_inzittende_id"
              field_name="tweede_inzittende_naam"
              title={$t("tweede inzitttende")}
              pilot={sleepVliegerTweedeInzittende}
              otherPilot={sleepVlieger}
              // vliegers gezagvoerder only non-pax
              vliegers={aanmeldingen.filter(
                (aanmelding) => aanmelding.id > 0 && aanmelding.as_sleepvlieger
              )}
              alle_vliegers={vliegers}
              flight={visibleSleepFlight}
              saveFlight={saveSleep}
              openPilot={null}
            />
            <Checkbox
              className="small"
              checked={visibleSleepFlight?.is_fis}
              disabled={!sleepVlieger?.is_instructeur}
              onChange={(click) => saveSleep({ is_fis: click.target.checked })}
            >
              FI(s){" "}
              <HelpBubble content="Trainingsvlucht om met een sleepvliegtuig te mogen slepen, alleen mogelijk indien sleepvlieger instructeur is." />
            </Checkbox>
          </div>
        )}

        {isAerotow && (
          <div
            className="row"
            style={{ alignItems: "flex-start", marginTop: 6 }}
          >
            <p style={{ margin: "5px 0" }}>
              {$t("Zweefvlieger (PIC)")}:{" "}
              <span style={{ marginLeft: 5 }}>
                {(visibleFlight && visibleFlight.gezagvoerder_naam) ||
                  $t("Onbreekt")}
              </span>
            </p>
          </div>
        )}

        <div className="row" style={{ alignItems: "flex-start", marginTop: 6 }}>
          <p
            style={{
              marginTop: 5,
            }}
          >
            {$t("Betalend lid")}:
          </p>
          <SelectPilot
            hideAvatar
            readOnly={readOnly}
            field_id="betalend_lid_id"
            field_name="betalend_lid_naam"
            title={$t("Betalend lid")}
            pilot={betalendLid}
            // vliegers gezagvoerder only non-pax
            vliegers={aanmeldingen.filter((a) => a.id > 0)}
            alle_vliegers={vliegers.filter((v) => v.id > 0)}
            flight={visibleSleepFlight}
            saveFlight={(data) => {
              // not saving sleep, this remains empty
              const newData = { betalend_lid_id: data.betalend_lid_id };
              saveSleep(newData);

              // for aerotow, we can also change the gezagvoerder if required
              // ps, we can set the betalend lid irrespective of the voucher
              if (visibleFlight && !visibleFlight.gezagvoerder_id && data) {
                newData.gezagvoerder_id = data.betalend_lid_id;
                newData.gezagvoerder_naam = data.betalend_lid_naam;
              }
              saveFlight(newData);
            }}
            openPilot={null}
          />
        </div>

        {hasFinance && (
          <div
            className="row"
            style={{ alignItems: "flex-start", marginTop: 6 }}
          >
            <p
              style={{
                marginRight: 6,
              }}
            >
              {$t("Bon")}:
            </p>

            <VoucherSelector
              readOnly={readOnly}
              flight={visibleFlight}
              sleepFlight={visibleSleepFlight}
              saveFlight={saveFlight}
              saveSleepFlight={saveSleep}
            />
          </div>
        )}

        <Divider orientation="left" plain>
          {$t("Tijden Sleepkist")}:
        </Divider>

        <SectionTijd
          readOnly={readOnly}
          flight={visibleSleepFlight}
          saveFlight={(d) => {
            saveSleep(d);
            if (d.start_tijd)
              saveFlight(
                calculateLandingTimeBasedOnNewStarttime(
                  d.start_tijd,
                  visibleFlight.vluchtduur
                )
              );
          }}
        />

        {selectedSleepKist && selectedSleepKist.motor_byflight && (
          <div style={{ marginTop: 6 }}>
            <FlightTacometer
              motor_format={selectedSleepKist.motor_format}
              flight={visibleSleepFlight}
              readOnly={visibleSleepFlight.is_locked}
              saveFlight={saveSleep}
            />
          </div>
        )}

        {visibleFlight && (
          <>
            <Divider orientation="left" plain>
              {$t("Tijden Zweefvliegtuig")}:
            </Divider>

            <SectionTijd
              readOnly={readOnly}
              flight={visibleFlight}
              saveFlight={(d) => {
                if (d.start_tijd)
                  saveSleep(
                    calculateLandingTimeBasedOnNewStarttime(
                      d.start_tijd,
                      visibleSleepFlight.vluchtduur,
                      true
                    )
                  );
                saveFlight(d);
              }}
            />
          </>
        )}

        <Divider orientation="left" plain>
          {$t("Details")}:
        </Divider>

        <div className="row" style={{ width: 220 }}>
          <p style={{ width: 170 }}>
            {$t("Hoogte")} {i18n.unit === "m" ? "(m)" : "(ft)"}:
          </p>
          <Input
            type="number"
            value={Math.round(
              i18n.convertHeightToLocale(visibleSleepFlight.height)
            )}
            onChange={(element) =>
              saveSleep({
                height: i18n.convertLocaleHeightToMetric(element.target.value),
              })
            }
            allowClear={false}
            disabled={readOnly}
          />
        </div>

        <div style={{ width: 200 }}>
          <CategorySelect
            readOnly={readOnly}
            currentFlight={visibleSleepFlight.uuid}
            currentValue={visibleSleepFlight.category}
            categories={sleep_cat}
            onSelect={(value) => saveSleep({ category: value })}
          />
        </div>

        <div style={{ width: 200, marginBottom: 6 }}>
          <p>{$t("Vliegvelden")}:</p>
          <Input
            value={visibleSleepFlight.vertrek_vliegveld}
            onChange={(element) => {
              saveSleep({ vertrek_vliegveld: element.target.value });
              saveFlight({ vertrek_vliegveld: element.target.value });
            }}
            addonBefore={<StartIcon />}
            disabled={readOnly}
            style={{ marginBottom: 3 }}
          />
          <Input
            value={visibleSleepFlight.aankomst_vliegveld}
            onChange={(element) =>
              saveSleep({ aankomst_vliegveld: element.target.value })
            }
            addonBefore={<LandingIcon />}
            disabled={readOnly}
          />
        </div>

        <div className="row" style={{ width: 200, marginBottom: 6 }}>
          <p style={{ marginRight: 12 }}>IGC:</p>
          {sleepFlight.igc ? (
            <IGCButton flight={sleepFlight} title={$t("Open")} />
          ) : (
            "-"
          )}
        </div>

        <div style={{ maxWidth: 350, marginBottom: 6 }}>
          <p>{$t("Beschrijving")}:</p>

          <Input.TextArea
            rows={2}
            disabled={readOnly}
            value={visibleSleepFlight.beschrijving}
            onChange={(element) => {
              saveSleep({ beschrijving: element.target.value });
              saveFlight({ beschrijving: element.target.value });
            }}
          />
        </div>

        {currentUser?.wijzig_vluchten && sleepFlight.is_locked && (
          <div className="row" style={{ marginTop: 12 }}>
            <span>{$t("Wijzig vlucht als admin")}:</span>
            <Switch
              style={{ marginLeft: 6 }}
              checked={forceEdit}
              onChange={setForceEdit}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
